import script from "./ParticipantsPresences.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantsPresences.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantsPresences.vue?vue&type=style&index=0&id=27f44d8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f44d8c"]])

export default __exports__